<template>
  <div>
    <h2>Contact</h2>
    <p>
      Need something? We are here to help. Please get in touch by email at
      <a href="mailto: hello@cofocus.one">hello@cofocus.one</a> and our team
      will answer all your questions & queries.
    </p>
    <p>
      Pro tip: You can use a unicorn or dragon emoji in your email title to get
      a reply sooner! We love unicorns and dragons. 🦄🐲
    </p>
  </div>
</template>

<script>
export default {
  name: "Contact",
  mounted() {
    window.mixpanel.track("Visit Contact Page");
  }
};
</script>